import { Input } from 'antd';
import { FC } from 'react';
import { ReactComponent as Dollar } from 'Assets/decor/dollar.svg';
import styles from './InputWithLine.module.scss';
import {
  CalcInputData,
  CalcInputHandler,
} from 'Components/OrderCalc/OrderCalc';

type InputWithLineProps = {
  value: number;
  onChange: CalcInputHandler;
  data: CalcInputData;
  isPerMileType?: boolean;
};

const InputWithLine: FC<InputWithLineProps> = ({
  value,
  onChange: handleInputChange,
  data,
  isPerMileType,
}) => {
  const { name, totalMiles } = data;
  const isRevenuePerMileType = name === 'revenue' && isPerMileType;
  const isBrokerOrRevenuePrices = ['revenue', 'broker'].includes(name);

  return (
    <div className={styles.inputWithLine}>
      <Input
        className={styles.inputWithLine__input}
        name={name}
        prefix={
          <div className={styles.inputWithLine__prefix}>
            <Dollar className={styles.inputWithLine__prefix__sign} />
            {isPerMileType && (
              <span className={styles.inputWithLine__prefix__mi}>/mi</span>
            )}
            <span className={styles.inputWithLine__prefix__line}>|</span>
          </div>
        }
        value={value ? (isRevenuePerMileType ? value + '%' : value) : undefined}
        type={isBrokerOrRevenuePrices ? 'text' : 'number'}
        onChange={(event) => handleInputChange(event, data, isPerMileType)}
        disabled={
          (totalMiles === 0 && !isBrokerOrRevenuePrices) ||
          (isBrokerOrRevenuePrices && value === 0)
        }
      />
    </div>
  );
};

export default InputWithLine;
